// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  LocalizableString,
  SchemaValue,
} from "./types";

export default {
  dtmi: __t.string(),
  name: __t.string(),
  get schema() {
    return SchemaValue;
  },
  writable: __t.bool(),
  get displayName() {
    return LocalizableString;
  },
  get description() {
    return LocalizableString;
  },
  comment: __t.option(__t.string()),
  parentRelationshipName: __t.option(__t.string()),
};
